export enum FavoritesFilterOption {
  My = 'my favorites',
  Team = "team's favorites"
}
